/* eslint-disable @typescript-eslint/no-explicit-any */

export const debounce = (fn: any, time = 0) => {
	let timer: NodeJS.Timeout;

	return (...args: any[]) => {
		clearTimeout(timer);

		timer = setTimeout(() => {
			fn(...args);
		}, time);
	};
};
